export interface SavedReportsTranslation {

  // code picker
  search: string;

  // form saved reports
  hide_details: string;
  show_details: string;

  // saved report
  add_reports: string;
  add_report_by_id: string;
  add_new_report: string;

  // saved report menu
  edit_report: string;
  remove: string;
  remove_all: string;
  move_up: string;
  move_down: string;

  // saved report modal
  add_saved_reports_title: string;
  disabled: string;
  done: string;
}

export interface SavedReportsEndpoints {
  savedReportEvaluation: string;
  savedReportsOptions: string;
}

export const enum SavedReportCategory {
  caseReport = 1,
  numeratorReport = 2,
  statisticalReport = 3,
  riskReport = 12
}
